module.exports = __webpack_public_path__ + "img/soft.7547af92.png";